/* eslint-disable import/order */
import { MenuIdCommunications } from '@jira/navigation-apps__constants/src/MenuIdCommunications.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStakeholderGroupsRoute } from '@jira/router-routes__communications-routes/src/communicationsStakeholderGroupsRoute.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { StakeholdersSkeleton } from '@jira/platform__skeletons/src/ui/stakeholder-management/StakeholdersSkeleton.tsx';
import { stakeholderGroupsPageEntryPoint } from './ui/stakeholder-groups/stakeholderGroupsPageEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const communicationsStakeholderGroupsRouteEntry: Route = createEntry(
	communicationsStakeholderGroupsRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MenuIdCommunications,
		},

		skeleton: StakeholdersSkeleton,

		entryPoint: () => {
			return stakeholderGroupsPageEntryPoint;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
